import { EventEmitter, Injectable } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { StorageKeys } from 'src/app/shared-module-files/simpo.constant';
import { Observable, of, Subject, tap } from 'rxjs';
import { map, catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class StaffServiceService {

  constructor(
    public dialog: MatDialog,
    private http: HttpClient,
    private snackbar: MatSnackBar,
  ) { }

  private favUpdatedSource = new Subject<void>();
  favUpdated$ = this.favUpdatedSource.asObservable();
  storedetail: any;
  private cycleSelectedSource = new Subject<any>();
  // cycleSelected = this.cycleSelectedSource.asObservable();
  cycleSelected = new EventEmitter<any>();

  selectCycle(cycle: any) {
    this.cycleSelectedSource.next(cycle);
  }

  notifyFavUpdated() {
    this.favUpdatedSource.next();
  }
  openDialog(componentName: any, height: any, width: any, dataModel: any) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: true,
    });
  }
  openServiceDialog(componentName: any, height: any, width: any, maxWidth: any, dataModel: any, position: any = { right: '0px', top: '0px' }) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      maxWidth: maxWidth,
      data: dataModel,
      disableClose: true,
      position: position,
    });
  }
  openSocialBrand(componentName: any, height: any, width: any, data: any) {
    return this.dialog.open(componentName, {
      height: height,
      width: width,
      data: data,

    });
  }
  openSnack(message: any, action: any) {
    this.snackbar.open(message, action, { duration: 5000 });
  }

  createStaff(data: any) {
    return this.http.post(
      environment.baseUrl + `staff/staff`, data
    )
  }

  createUpdateTeam(data: any) {
    return this.http.post(
      environment.baseUrl + `staff/team`, data
    )
  }

  createUpdateRole(data: any) {
    return this.http.post(environment.baseUrl + `staff/user-role`, data)
  }

  getRoleListing(payload: { pageNo: number; size: number; searchText: string | null; businessId: string }) {
    return this.http.put(environment.baseUrl + `staff/user-role/filter`, payload)
  }

  deleteUserRole(roleId: string) {
    return this.http.delete(environment.baseUrl + `staff/user-role/${roleId}`)
  }

  getTeamListing(payload: { pageNo: number; size: number; searchText: string | null; businessId: string }) {
    return this.http.put(
      environment.baseUrl + `staff/team/filter`, payload
    )
  }

  deleteTeam(teamId: string) {
    return this.http.delete(
      environment.baseUrl + `staff/team/${teamId}`
    )
  }

  updateStaff(staffId: any, data: any) {
    return this.http.put(
      environment.baseUrl + `staff/staff/update?staffId=${staffId}`, data
    )
  }

  updateAppointmentStaffDetails(data: any, businessId: any, staffId: any) {
    return this.http.put(
      environment.baseUrl + `staff/staff/store-level-details/${businessId}/${staffId}`, data
    )
  }
  getStaffListing(businessId: any, pageNo: number, size: number, status: any) {
    return this.http.get(
      environment.baseUrl + `staff/staff/list/${businessId}?page=${pageNo}&size=${size}&status=${status}`
    )
  }

  getStaffPermissionByStaffId(staffId: any, businessId: any) {
    return this.http.get(
      environment.baseUrl + `staff/staff/get/permission?staffId=${staffId}&businessId=${businessId}`
    )
  }
  staffFilter(pageNo: any, size: any, data: any) {
    return this.http.put(
      environment.baseUrl + `staff/staff/filter?page=${pageNo}&size=${size}`, data
    )
  }

  deleteStaff(staffId: any, businessId?: any) {
    return this.http.delete(
      environment.baseUrl + `staff/staff/inactivate/${staffId}?businessId=${localStorage.getItem('businessId')}`
    )
  }

  getStaffDetailsByStaffId(staffId: any) {
    return this.http.get(
      environment.baseUrl + `staff/staff/${staffId}`
    )
  }

  changeToggleStaff(data: any, staffId: any, status: any) {
    return this.http.put(
      environment.baseUrl + `staff/staff/status/${staffId}?status=${status}`, data
    )
  }

  // for assign the staff
  assignStaff(data: any) {
    return this.http.post(
      environment.baseUrl + `staff/permission/assign`, data
    )
  }

  updateUserPermission(data: { staffId: string; businessId: string; permission: any }) {
    return this.http.put(
      environment.baseUrl + `staff/staff/user-permission/update`, data
    );
  }
  getStaffPermission(subModule?: any, access?: 'VIEW' | 'EDIT' | 'CREATE' | 'DELETE', module?: any) {
    try {
      const stored = JSON.parse(localStorage.getItem(StorageKeys.PERMISSIONS) || 'null');
      if (!stored) return false;

      if (stored.admin === true) return true;

      const perm = stored.permission;
      if (!perm || Object.keys(perm).length === 0) return false;

      const codeMap = JSON.parse(localStorage.getItem(StorageKeys.APP_CODE_MAP) || 'null');

      // Normalize: uppercase + spaces/hyphens → underscore so 'POST SUMMARY' → 'POST_SUMMARY'
      const norm = (s: string) => (s || '').toUpperCase().replace(/[\s-]+/g, '_').trim();
      // create-staff.component.ts stores permission keys as plain `appName.toUpperCase()` (spaces kept)
      const upper = (s: string) => (s || '').toUpperCase().trim();

      // Resolve to whichever key actually has data in `perm` — try the codeMap-resolved
      // backend code first, then fall back to the literal uppercased name used by create-staff.
      const resolveApp = (name: string) => {
        const mapped = codeMap?.appNameToCode?.[norm(name)];
        if (mapped && perm[mapped]) return mapped;
        if (perm[upper(name)]) return upper(name);
        return mapped || name;
      };

      const resolveSub = (appKey: string, name: string) => {
        const appCode = codeMap?.appNameToCode?.[norm(appKey)] || appKey;
        const mapped = codeMap?.subAppCodeByAppCode?.[appCode]?.[norm(name)];
        const appPerms = perm[appKey];
        if (mapped && appPerms?.[mapped]) return mapped;
        if (appPerms?.[upper(name)]) return upper(name);
        return mapped || name;
      };

      // No module — subModule is the app name
      // e.g. getStaffPermission('CRM')  or  getStaffPermission('CRM', 'VIEW')
      if (!module) {
        const appCode = resolveApp(subModule);
        const appPerms = perm[appCode];
        if (!appPerms) return false;

        // Apps with no sub-modules store permissions as a flat array (e.g. perm['PRODUCT'] = ['VIEW','EDIT'])
        if (Array.isArray(appPerms)) {
          if (access) return appPerms.includes(access);
          return appPerms.length > 0;
        }

        if (access) {
          // Check if ANY sub-module has the requested access type
          return Object.values(appPerms).some((v: any) => Array.isArray(v) && v.includes(access));
        }
        // Check if app has any permission at all
        return Object.values(appPerms).some((v: any) => Array.isArray(v) && v.length > 0);
      }

      // Full call: getStaffPermission('CAMPAIGN', 'CREATE', 'CRM')
      const resolvedModule = resolveApp(module);
      const resolvedSubModule = resolveSub(resolvedModule, subModule);

      if (access) {
        return !!(perm?.[resolvedModule]?.[resolvedSubModule]?.includes(access));
      }
      return !!(perm?.[resolvedModule]?.[resolvedSubModule]?.length > 0);
    } catch {
      return false;
    }
  }

  showSidePanel() {
    let response: any = {};
    try {
      const stored = JSON.parse(localStorage.getItem(StorageKeys.PERMISSIONS) || 'null');

      // admin: true → sidenav uses isStaffAdmin() = true → shows all, this method not needed
      if (!stored || stored.admin) return response;

      const permObj = stored.permission;   // { "APPCODE": { "SUBCODE": ["VIEW",...] } }
      if (!permObj || Object.keys(permObj).length === 0) return response;

      for (const appCode of Object.keys(permObj)) {
        response[appCode] = {};
        let hasAny = false;

        for (const subCode of Object.keys(permObj[appCode] || {})) {
          const hasPerms = (permObj[appCode][subCode]?.length || 0) > 0;
          response[appCode][subCode] = hasPerms;
          if (hasPerms) hasAny = true;
        }

        response[appCode]['show'] = hasAny;
      }
    } catch {
      // safe default: empty = no filtering
    }
    return response;
  }

  /**
   * Derives and stores permissions from the login API response business list.
   * Call this whenever a business is selected — replaces all old staffPermission/cmisPermission API calls.
   */
  setPermissionsFromBusinessList(businessId: string): void {
    // Read from loggedInUser — the full login API response stored at login
    // This is more reliable than 'business' key which can be overwritten elsewhere
    const loggedInUser = JSON.parse(localStorage.getItem(StorageKeys.LOGGED_IN_USER) || 'null');
    const businessList: any[] = loggedInUser?.business || [];
    const biz = businessList.find((b: any) => b.id === businessId);
    if (!biz) return;

    // v2 roles carry a flat permissionKeys array (e.g. "crm.lead.read"). Prefer it and
    // convert to the nested { APP: { SUB: [ACTIONS] } } shape the rest of the app uses.
    const v2Keys: string[] =
      (Array.isArray(biz.permissionKeys) && biz.permissionKeys) ||
      (Array.isArray(biz.role?.permissionKeys) && biz.role.permissionKeys) ||
      (Array.isArray(biz.permission) && biz.permission) ||
      (Array.isArray(biz.role?.permission) && biz.role.permission) ||
      [];

    // biz.permission holds permissions set directly on the user; if absent, fall back to the
    // assigned role's permission so refreshes don't wipe what was set at login
    const directPerm = biz.permission && !Array.isArray(biz.permission) && Object.keys(biz.permission).length > 0 ? biz.permission : null;
    const rolePerm = biz.role?.permission && !Array.isArray(biz.role.permission) && Object.keys(biz.role.permission).length > 0 ? biz.role.permission : null;

    let permission: any;
    if (v2Keys.length) {
      permission = this.v2KeysToNestedPermission(v2Keys);
      localStorage.setItem(StorageKeys.PERMISSION_KEYS_V2, JSON.stringify(v2Keys));
    } else {
      permission = directPerm || rolePerm || {};
      localStorage.removeItem(StorageKeys.PERMISSION_KEYS_V2);
    }

    const permissions = { admin: biz.admin === true, permission };
    localStorage.setItem(StorageKeys.PERMISSIONS, JSON.stringify(permissions));
    localStorage.setItem('type', biz.admin ? 'admin' : 'staff');
  }

  /** v2 action codes → legacy VIEW/EDIT/CREATE/DELETE vocabulary used across the app. */
  private static readonly V2_TO_LEGACY_ACTION: Record<string, string> = {
    read: 'VIEW', view: 'VIEW',
    create: 'CREATE',
    edit: 'EDIT', update: 'EDIT',
    delete: 'DELETE',
    export: 'EXPORT', import: 'IMPORT',
    assign: 'ASSIGN', send: 'SEND', approve: 'APPROVE',
  };

  /** "crm.lead.read" -> { CRM: { LEAD: ['VIEW'] } } (keys uppercased to match the sidenav fallbacks). */
  private v2KeysToNestedPermission(keys: string[]): Record<string, Record<string, string[]>> {
    const out: Record<string, Record<string, string[]>> = {};
    for (const raw of keys) {
      const parts = String(raw).split('.').filter(Boolean);
      if (parts.length < 2) continue;
      const app = parts[0].toUpperCase();
      const sub = (parts.length >= 3 ? parts[1] : parts[0]).toUpperCase();
      const actRaw = parts[parts.length - 1].toLowerCase();
      const act = StaffServiceService.V2_TO_LEGACY_ACTION[actRaw] || actRaw.toUpperCase();
      if (!out[app]) out[app] = {};
      if (!out[app][sub]) out[app][sub] = [];
      if (!out[app][sub].includes(act)) out[app][sub].push(act);
    }
    return out;
  }

  /** True if the logged-in user was granted this exact v2 permission key (e.g. "crm.lead.export"). */
  hasV2Permission(permissionKey: string): boolean {
    try {
      if (this.isStaffAdmin()) return true;
      const keys: string[] = JSON.parse(localStorage.getItem(StorageKeys.PERMISSION_KEYS_V2) || '[]');
      return keys.includes(permissionKey);
    } catch {
      return false;
    }
  }

  /**
   * Fetches latest staff details from server, updates loggedInUser + PERMISSIONS in localStorage,
   * then emits updateSidePanel so sidenav refreshes — no re-login needed.
   */
  refreshPermissionsFromServer(silentEmitter?: { emit: () => void }): void {
    const staffId = localStorage.getItem(StorageKeys.STAFF_ID);
    const businessId = localStorage.getItem('businessId');
    if (!staffId || !businessId) return;

    this.getStaffDetailsByStaffId(staffId).pipe(
      catchError(() => of(null))
    ).subscribe((res: any) => {
      if (!res?.data?.business) return;

      // Snapshot current permissions to detect actual change
      const before = localStorage.getItem(StorageKeys.PERMISSIONS);

      // Update loggedInUser with fresh business list from server
      const loggedInUser = JSON.parse(localStorage.getItem(StorageKeys.LOGGED_IN_USER) || '{}');
      loggedInUser.business = res.data.business;
      localStorage.setItem(StorageKeys.LOGGED_IN_USER, JSON.stringify(loggedInUser));

      // Re-apply permissions for current business
      this.setPermissionsFromBusinessList(businessId);

      const after = localStorage.getItem(StorageKeys.PERMISSIONS);

      // Only emit if permissions actually changed — avoids unnecessary sidenav re-checks
      if (silentEmitter && before !== after) {
        silentEmitter.emit();
      }
    });
  }

  isStaffAdmin() {
    try {
      const permission = JSON.parse(localStorage.getItem(StorageKeys.PERMISSIONS) || 'null');
      if (permission?.admin) {
        localStorage.setItem('staffType', String(permission.admin));
      }
      return permission?.admin === true;
    } catch {
      return false;
    }
  }

  loadStaffStoreDetails() {
    let staffId: any = localStorage.getItem(StorageKeys.STAFF_ID)
    let businessId: any = localStorage.getItem('businessId');

    if (!staffId || !businessId)
      return

    return this.http.get(environment.baseUrl + `staff/staff/store-level?staffId=${staffId}&businessId=${businessId}`).pipe(
      tap((res: any) => this.storedetail = res?.data?.data)
    );
  }

  getStaffStoreDetails() {
    if (this.isStaffAdmin())
      return { admin: true, store: [] }

    return { admin: false, store: this.storedetail?.map(store => store.storeId) };
  }

  getStaffWorkingHours(staffId: any) {
    return this.http.get(environment.baseUrl + `staff/staff/store-level-staff?staffId=${staffId}&businessId=${localStorage.getItem('businessId')}`);
  }

  getStaffDateWiseWorkingHours(staffId: any) {
    return this.http.get(environment.baseUrl + `staff/staff/date-wise-working-hours?staffId=${staffId}&businessId=${localStorage.getItem('businessId')}`);
  }

  getAllAppointmentService(payload: any) {
    return this.http.put(
      environment.appointementUrl + 'service/list', payload
    )
  }
  getStaffAvailabilityData(businessId: any, storeId?: any) {
    let url = `staff/staff/get/available?businessId=${businessId}`
    if (storeId) {
      url = url += `&storeId=${storeId}`
    }
    return this.http.get(environment.baseUrl + url)
  }
  updateStaffAvailability(payload: any) {
    return this.http.put(environment.baseUrl + `staff/staff/update/availability`, payload)
  }
  updateWorkingDates(payload: any) {
    return this.http.post(environment.baseUrl + `staff/staff/update/staff/leave`, payload)
  }


  getstaffV2Permission(businessId?: any){
    const bId = businessId || localStorage.getItem('businessId') || '';
    return this.http.get(
      environment.baseUrl + `staff/permission/v2/definitions/business?businessId=${bId}`
    )
  }

  createRoleV2Permission(payload: any){
    return this.http.post(
      environment.baseUrl + `staff/permission/v2/roles`, payload
    )
  }

  // PUT /permission/v2/roles/{roleId}  body: { businessId, name, permissionKeys: [] }
  updateRoleV2Permission(roleId: any, payload: any){
    return this.http.put(
      environment.baseUrl + `staff/permission/v2/roles/${roleId}`, payload
    )
  }
}
